import React from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';

import { getBoxShadowStyle } from '@styles/shadow';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const FieldsWrapper = ({ children, C }: { children: React.ReactNode; C: ColorFunction }) => {
  return (
    <View
      style={[
        getBoxShadowStyle({ type: 'Field', C }),
        {
          borderRadius: scale(SCREEN_BORDER_RADIUS),
        },
      ]}
    >
      <View style={{ borderRadius: scale(SCREEN_BORDER_RADIUS), overflow: 'hidden' }}>{children}</View>
    </View>
  );
};

export default ColorWrapper(FieldsWrapper);
